import { Share2, Target, Search, PenTool, BarChart3 } from "lucide-react";
import { SERVICES } from "@/site-data";
import { Reveal, Eyebrow } from "./Reveal";

const ICONS = { Share2, Target, Search, PenTool, BarChart3 };

export default function Services() {
  return (
    <section id="hizmetler" className="relative py-24 md:py-32">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[600px] -translate-x-1/2 rounded-full bg-[#1E7FFF]/10 blur-[160px]" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <Eyebrow>Hizmetlerimiz</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 max-w-2xl font-syne text-3xl font-bold tracking-tight md:text-5xl">
            Dijital Büyümeniz İçin <span className="text-[#1E7FFF]">Eksiksiz Hizmet Seti.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[#B9C4E8]">
            Stratejiden içeriğe, reklamdan raporlamaya — markanızın dijitalde ihtiyaç duyduğu
            tüm uzmanlığı tek ekipten alın.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.id} delay={0.06 * i} className="h-full">
                <div
                  data-testid={`service-card-${s.id}`}
                  className="group relative h-full rounded-2xl border border-[#2E4390] bg-[#1A2E78]/70 p-7 backdrop-blur-md transition-all duration-300 hover:-translate-y-1.5 hover:border-[#1E7FFF] hover:shadow-[0_20px_50px_rgba(30,127,255,0.25)]"
                >
                  <span className="pointer-events-none absolute right-6 top-5 font-syne text-4xl font-extrabold text-[#2E4390] transition-colors duration-300 group-hover:text-[#1E7FFF]">
                    {s.number}
                  </span>
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#1E7FFF]/15 text-[#5CA3FF] transition-all duration-300 group-hover:bg-[#1E7FFF] group-hover:text-white">
                    <Icon size={22} />
                  </span>
                  <h3 className="mt-5 font-syne text-lg font-bold md:text-xl">{s.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#B9C4E8]">{s.desc}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.chips.map((c) => (
                      <span
                        key={c}
                        className="rounded-full border border-[#2E4390] bg-[#122263]/80 px-3 py-1 font-code text-[10px] tracking-wide text-[#8B9AC4]"
                      >
                        {c}
                      </span>
                    ))}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
